import { render, staticRenderFns } from "./searchDataPl.vue?vue&type=template&id=fc074bd8&scoped=true&"
import script from "./searchDataPl.vue?vue&type=script&lang=js&"
export * from "./searchDataPl.vue?vue&type=script&lang=js&"
import style0 from "./searchDataPl.vue?vue&type=style&index=0&id=fc074bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc074bd8",
  null
  
)

export default component.exports